export function roundN(num, digit) {
  const pow = 10 ** digit
  return Math.round(num * pow) / pow
}

export function round2(num) {
  return Math.round(num * 100) / 100
}

export function floorN(num, n) {
  const pow = 10 ** n
  return Math.floor(num * pow) / pow
}

export function floor2(num) {
  return floorN(num, 2)
}

export function regression(data) {
  const v = [0, 0, 0, 0]

  data.forEach((elem, i) => {
    v[0] += i
    v[1] += elem
    v[2] += i * i
    v[3] += i * elem
  })

  const m =
    (data.length * v[3] - v[0] * v[1]) / (data.length * v[2] - v[0] * v[0])
  const b = v[1] / data.length - (m * v[0]) / data.length

  return (x) => m * x + b
}

export default {
  roundN,
  round2,
  floor2,
  floorN,
  regression,
}
